const voterButtons = ["Candidate", "Campaign", "Party"];

export default voterButtons;



// WEBPACK FOOTER //
// ./src/content/Home-VoterButtons.js